/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Property_CreatedInputs */

const cs_event_property_created = /** @type {(inputs: Event_Property_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost vytvořena`)
};

const en_event_property_created = /** @type {(inputs: Event_Property_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property created`)
};

/**
* | output |
* | --- |
* | "Property created" |
*
* @param {Event_Property_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const event_property_created = /** @type {((inputs?: Event_Property_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Property_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_property_created(inputs)
	return cs_event_property_created(inputs)
});